(() => {
  const initMarquee = (section) => {
    if (!section) return;

    const slider = section.querySelector(".js-slider-logos");
    const sliderWrapper = slider.querySelector(".js-slider-logos-wrapper");
    const logoSlides = section.querySelectorAll(".logo-card");
    
    if (!slider || !sliderWrapper || !logoSlides.length) {
      console.warn('Logo list marquee: Missing required elements');
      return;
    }

    // Remove all Swiper classes and attributes
    slider.classList.remove('swiper');
    sliderWrapper.classList.remove('swiper-wrapper');
    logoSlides.forEach(slide => {
      slide.classList.remove('swiper-slide');
      slide.removeAttribute('data-swiper-slide-index');
    });

    // Add marquee class
    section.classList.add('logo-list--marquee');
    
    // Clone all logos for seamless infinite scroll
    const originalSlides = Array.from(logoSlides);
    originalSlides.forEach(slide => {
      const clone = slide.cloneNode(true);
      // Ensure clone has same classes but no Swiper attributes
      clone.className = slide.className;
      clone.setAttribute('data-cloned', 'true');
      sliderWrapper.appendChild(clone);
    });

    // Get speed setting from data attribute (convert from ms to seconds)
    const speedSetting = parseInt(slider.dataset.duration) || 4000;
    const speedMultiplier = speedSetting / 1000; // Convert to seconds
    
    // Calculate animation duration based on content width and speed setting
    const totalWidth = sliderWrapper.scrollWidth;
    const containerWidth = slider.offsetWidth;
    const baseDuration = Math.max(10, (totalWidth / 100)); // Base duration
    const duration = baseDuration * speedMultiplier; // Apply speed setting
    
    // Apply CSS animation with calculated duration
    sliderWrapper.style.animation = `marquee ${duration}s linear infinite`;
    
    // Pause on hover if enabled
    const stopOnHover = slider.dataset.stopOnHover === "true";
    if (stopOnHover) {
      slider.addEventListener("mouseenter", () => {
        sliderWrapper.style.animationPlayState = 'paused';
      });
      
      slider.addEventListener("mouseleave", () => {
        sliderWrapper.style.animationPlayState = 'running';
      });
    }

    // Add touch pause for mobile devices
    let touchStartY = 0;
    slider.addEventListener('touchstart', (e) => {
      touchStartY = e.touches[0].clientY;
    });

    slider.addEventListener('touchmove', (e) => {
      const touchY = e.touches[0].clientY;
      const diffY = Math.abs(touchY - touchStartY);
      
      // Pause animation if user is scrolling vertically
      if (diffY > 10) {
        sliderWrapper.style.animationPlayState = 'paused';
      }
    });

    slider.addEventListener('touchend', () => {
      // Resume animation after a short delay
      setTimeout(() => {
        sliderWrapper.style.animationPlayState = 'running';
      }, 500);
    });

    console.log('Logo list marquee: Initialized with', {
      originalLogos: originalSlides.length,
      totalWidth,
      containerWidth,
      speedSetting: `${speedSetting}ms`,
      duration: `${duration.toFixed(1)}s`
    });
  };

  // Initialize on current section
  initMarquee(document.currentScript.parentElement);

  // Initialize on section load
  document.addEventListener("shopify:section:load", function (section) {
    console.log('Logo list marquee: Section loaded, initializing...');
    initMarquee(section.target);
  });

  // Initialize on DOM ready for any existing sections
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      console.log('Logo list marquee: DOM ready, initializing existing sections...');
      document.querySelectorAll('.js-slider-logos').forEach(slider => {
        const section = slider.closest('.logo-list');
        if (section) initMarquee(section);
      });
    });
  } else {
    console.log('Logo list marquee: DOM already ready, initializing existing sections...');
    document.querySelectorAll('.js-slider-logos').forEach(slider => {
      const section = slider.closest('.logo-list');
      if (section) initMarquee(section);
    });
  }
})();
